import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserStorage } from 'Redux/services/storage'
import { COMPARED_LISTINGS_BS_KEY } from 'Redux/modules/compare/sagas'

import SvgIcon from 'Components/SvgIcon'

import ListingRow from './components/ListingRow'

import { MAX_COMPARE_LISTING_COUNT, COMPARE_GA_CATEGORY, MIN_COMPARE_DESKTOP_WIDTH } from './index'

import {
  _CompareGrid, _Background, _ClickableLip, _GridBody,
  _GridBodyInner, _MainMessage, _FullMsg, _MsgAndCta, _CtaCol,
  _CompareBtn, _ClearBtn,
} from './styles'

const bs = browserStorage()

class CompareGrid extends Component {
  constructor(props) {
    super(props)
    this.state = {
      didClientSideMounted: false,
    }
    this.updateReduxComparables = this.updateReduxComparables.bind(this)
    this.handleClearAllCompareListings = this.handleClearAllCompareListings.bind(this)
  }

  componentDidMount() {
    this.updateReduxComparables()

    if(typeof window !== 'undefined') {
      window.addEventListener('storage', this.updateReduxComparables)
    }

    // eslint-disable-next-line
    if(!this.state.didClientSideMounted) this.setState({ didClientSideMounted: true })
  }

  componentDidUpdate(prevProps) {
    if(this.props.isCompareGridOpen !== prevProps.isCompareGridOpen) {
      this.props.googleAnalyticsEvent({
        category: COMPARE_GA_CATEGORY,
        action: [`Compare grid ${this.props.isCompareGridOpen ? 'Open' : 'Close'}`],
      })
    }
  }

  componentWillUnmount() {
    if(typeof window !== 'undefined') {
      window.removeEventListener('storage', this.updateReduxComparables)
      this.props.toggleCompareGrid({ isOpen: false })
    }
  }

  // loop through localstorage comparables and update redux state
  updateReduxComparables() {
    const localStorageComparables = bs.getItem(COMPARED_LISTINGS_BS_KEY) ?
      JSON.parse(bs.getItem(COMPARED_LISTINGS_BS_KEY)) : {}
    const reduxComparables = this.props.comparedListings
    if(reduxComparables !== localStorageComparables) {
      this.props.updateAllCompareListing(localStorageComparables)
    }
  }

  handleClearAllCompareListings() {
    const {
      comparedListings, googleAnalyticsEvent, clearAllCompareListing,
    } = this.props
    const listingCount = Object.keys(comparedListings || {}).length

    googleAnalyticsEvent({
      category: COMPARE_GA_CATEGORY,
      action: ['Clear All Clicked on Grid', `${listingCount} Listings Cleared`],
    })
    clearAllCompareListing()
  }

  render() {
    const {
      isAgentStickyBarVisible, comparedListings, removeCompareListing,
      toggleCompareGrid, isCompareGridOpen,
      userIsAuthentificated, openRegisterModal, showCompareFullWarning,
      googleAnalyticsEvent, winWidth,
    } = this.props

    const listingCount = Object.keys(comparedListings || {}).length

    const mlsNumberString = comparedListings ? Object.keys(comparedListings || {}).join(',') : ''
    const comparedUrl = mlsNumberString ?
      `/compare-listings?mls_number=${mlsNumberString}` : ''


    if(
      !this.state.didClientSideMounted ||
      listingCount === 0 ||
      winWidth <= MIN_COMPARE_DESKTOP_WIDTH
    ) return ''
    return (
      <_CompareGrid style={{ bottom: isAgentStickyBarVisible ? '88px' : '0' }} >
        <_Background
          isOpen={isCompareGridOpen}
          onClick={isCompareGridOpen ? () => { toggleCompareGrid({ isOpen: false }) } : null}
        >
          <_ClickableLip
            isOpen={isCompareGridOpen}
            onClick={!isCompareGridOpen ? () => { toggleCompareGrid({ isOpen: true }) } : null}
          >
            Compare {listingCount}
            <SvgIcon name="#icon-dropdown-arrow" width={10} height={10} />
          </_ClickableLip>
        </_Background>
        <_GridBody style={{ height: isCompareGridOpen ? '340px' : '0' }} >
          <_GridBodyInner>
            <_MsgAndCta>
              <_MainMessage>
                {
                  showCompareFullWarning ?
                    <_FullMsg>You can only select {MAX_COMPARE_LISTING_COUNT} listings to compare!</_FullMsg>
                    : `Selected ${listingCount}/${MAX_COMPARE_LISTING_COUNT} listings to compare.`
                }
              </_MainMessage>
              <_CtaCol>
                <_ClearBtn onClick={this.handleClearAllCompareListings}>
                  Clear all
                </_ClearBtn>
                <_CompareBtn
                  to={comparedUrl}
                  openNewTab
                  alt={'Compare Page'}
                  onClick={() => {
                    googleAnalyticsEvent({
                      category: COMPARE_GA_CATEGORY,
                      action: ['Compare Cta Clicked on Grid', `${listingCount} Listings Compared`],
                    })
                  }}
                >
                  Compare
                </_CompareBtn>
              </_CtaCol>
            </_MsgAndCta>

            <ListingRow
              comparedListings={comparedListings}
              removeCompareListing={removeCompareListing}
              userIsAuthentificated={userIsAuthentificated}
              openRegisterModal={openRegisterModal}
              googleAnalyticsEvent={googleAnalyticsEvent}
            />
          </_GridBodyInner>
        </_GridBody>
      </_CompareGrid>
    )
  }
}

CompareGrid.propTypes = {
  isAgentStickyBarVisible: PropTypes.bool,
  removeCompareListing: PropTypes.func,
  comparedListings: PropTypes.shape({}),
  updateAllCompareListing: PropTypes.func,
  clearAllCompareListing: PropTypes.func,
  toggleCompareGrid: PropTypes.func,
  isCompareGridOpen: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
  openRegisterModal: PropTypes.func,
  showCompareFullWarning: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  winWidth: PropTypes.number,
}

export default CompareGrid
